import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';
import { Toggle } from './Toggle';

interface OutsideColliderSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const OutsideColliderSection: React.FC<OutsideColliderSectionProps> = ({ config, setConfig }) => (
  <div className="w-full flex flex-col gap-3 p-4 rounded-3xl border bg-neutral-500/5 border-neutral-500/10 mb-4">
    <SectionLabel icon="fa-square" darkMode={config.darkMode}>Outside Collider</SectionLabel>
    
    <div className="flex items-center justify-between border border-white/5 p-2 rounded-xl">
        <span className="text-[10px] font-black uppercase opacity-60">Enabled</span>
        <Toggle active={config.outsideColliderEnabled} onClick={() => setConfig(p => ({...p, outsideColliderEnabled: !p.outsideColliderEnabled}))} />
    </div>
    
    {config.outsideColliderEnabled && (
        <>
            <div className="flex items-center justify-between border border-white/5 p-2 rounded-xl">
                <span className="text-[10px] font-black uppercase opacity-60">Culling Enabled</span>
                <Toggle active={config.outsideColliderCulling} onClick={() => setConfig(p => ({...p, outsideColliderCulling: !p.outsideColliderCulling}))} />
            </div>
            {config.outsideColliderCulling && (
                <SmartInput label="Culling Margin" min={0} max={500} step={5} value={config.outsideColliderCullingMargin} onChange={v => setConfig(p => ({...p, outsideColliderCullingMargin: v}))} darkMode={config.darkMode} />
            )}
            <SmartInput label="Width" min={100} max={4000} step={10} value={config.outsideColliderWidth} onChange={v => setConfig(p => ({...p, outsideColliderWidth: v}))} darkMode={config.darkMode} />
            <SmartInput label="Height" min={100} max={4000} step={10} value={config.outsideColliderHeight} onChange={v => setConfig(p => ({...p, outsideColliderHeight: v}))} darkMode={config.darkMode} />
            <SmartInput label="Scale" min={0.1} max={5.0} step={0.1} value={config.outsideColliderScale} onChange={v => setConfig(p => ({...p, outsideColliderScale: v}))} darkMode={config.darkMode} />
            <SmartInput label="Offset X" min={-2000} max={2000} step={10} value={config.outsideColliderOffsetX} onChange={v => setConfig(p => ({...p, outsideColliderOffsetX: v}))} darkMode={config.darkMode} />
            <SmartInput label="Offset Y" min={-2000} max={2000} step={10} value={config.outsideColliderOffsetY} onChange={v => setConfig(p => ({...p, outsideColliderOffsetY: v}))} darkMode={config.darkMode} />
            <SmartInput label="Bounciness" min={0} max={2} step={0.1} value={config.outsideColliderRestitution} onChange={v => setConfig(p => ({...p, outsideColliderRestitution: v}))} darkMode={config.darkMode} />
        </>
    )}
  </div>
);
